import { Cog } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Text, XStack } from 'tamagui';

export const InvalidConfiguration = () => {
  const { t } = useTranslation();

  return (
    <XStack
      flex={1}
      gap="$3.5"
      alignItems="center"
      justifyContent="center"
      backgroundColor="$black12">
      <Cog height={32} width={32} />
      <Text fontSize="$7.5" fontWeight="$5" color="$white12">
        {t('common.invalidConfiguration')}
      </Text>
    </XStack>
  );
};
